/*
 * @Author: zhushitao
 * @Date: 2021-08-10 17:38:16
 * @LastEditors: zhushitao
 * @LastEditTime: 2021-08-26 18:11:38
 * @Description:
 */

import Starling from '@ies/starling_client';
import { I18nConstructor } from '@ies/starling_intl';

import { Lang } from '../constants/lang';
import en from '../locales/en';
import zh from '../locales/zh';

const I18n = new I18nConstructor();

I18n.init({
  // Initialization language
  lng: Lang.zh,
  resources: {
    en: {
      translation: en,
    },
    zh: {
      translation: zh,
    },
  },
  fallbackLng: ['en', 'zh'],
  thirdParamFallback: true,
});

export function fetchLocaleData(
  lang = 'zh',
  internation = false,
  otherParams?: {
    lazyUpdate?: boolean;
  },
) {
  return new Promise((resolve, reject) => {
    I18n.setLang(lang);
    const starling = new Starling({
      // lazyUpdate: true,
      // cache: true,
      // eslint-disable-next-line @typescript-eslint/camelcase
      ...otherParams,
      api_key: '9f75a950f9b411eb95980d5a80016f56',
      namespace: 'linkchat-pro-sdk',
      locale: lang,
      zoneHost: internation
        ? 'https://starling-oversea.byteoversea.com'
        : 'https://starling.zijieapi.com',
      TEAChannelDomain: internation
        ? 'https://sgali-mcs.byteoversea.com'
        : 'https://mcs.zijieapi.com',
      timeout: 4000,
      mode: process.env.NODE_ENV === 'development' ? 'test' : 'normal',
    });

    starling.load(
      (texts) => {
        I18n.addResourceBundle(lang, 'translation', texts, true, true);
        resolve(texts);
      },
      (e) => {
        reject(e);
      },
    );
  });
}

const initI18N = async (lang: string = 'zh', isOversea?: boolean) => {
  try {
    const nss = await fetchLocaleData(lang, isOversea);
    I18n.addResourceBundle(lang, 'translation', nss, true, true);
  } catch (error) {
    console.log('fetchStarlingNS Error', error);
  }
  await I18n.setLang(lang);
};

const initI18NLazy = async (lang: string = 'zh', isOversea?: boolean) => {
  try {
    const nss = await fetchLocaleData(lang, isOversea, {
      lazyUpdate: true,
    });
    I18n.addResourceBundle(lang, 'translation', nss, true, true);
  } catch (error) {
    console.log('fetchStarlingNS Error', error);
  }
  await I18n.setLang(lang);
};
export { initI18N, I18n, initI18NLazy };
